import React from "react";
const SvgPoiMetro = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#39434E"
        d="M12 24C5.372 24 0 18.627 0 12S5.372 0 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12z"
      />
      <path
        fill="#FFF"
        d="M7.687 6.062c-.896 0-1.625.73-1.625 1.626v8.625c0 .896.729 1.625 1.625 1.625h8.626c.895 0 1.624-.73 1.624-1.625V7.688c0-.896-.729-1.626-1.624-1.626H7.687zM16.313 19H7.687A2.69 2.69 0 015 16.313V7.688A2.69 2.69 0 017.687 5h8.626A2.69 2.69 0 0119 7.688v8.625A2.69 2.69 0 0116.313 19z"
      />
      <path
        fill="red"
        d="M16.316 6.05H7.684c-.903 0-1.635.731-1.635 1.633v8.634c0 .901.732 1.633 1.635 1.633h8.632c.902 0 1.633-.732 1.633-1.633V7.683c0-.902-.731-1.633-1.633-1.633"
      />
      <path
        fill="#FFF"
        d="M15.082 7.437H12.79l-.845 4.332-.847-4.332H8.807l-1.683 8.615h1.684l1.144-5.855 1.144 5.855h1.696l1.143-5.855 1.145 5.855h1.685z"
      />
    </g>
  </svg>
);
export default SvgPoiMetro;
